
/* injects from baggage-loader */

'use strict';
import regions from './tab-device.const';
import { PlatesType } from '../types/plates';

import { chain } from 'lodash';

import reflexo from '_images/stage-three/reflexo.png';

export default class tabDeviceController {
    constructor($log, $rootScope, Dialog) {
        'ngInject';
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.Dialog = Dialog;
        this.reflexo = reflexo;
        this.tabState = 0;
        

        this.tabs = [
            {
                title: "Entrada",
                index: 1
            },
            {
                title: "Prato Principal",
                index: 2
            },
            {
                title: "Sobremesa e Bebida",
                index: 3
            }        
        ]

        this.state = {
            step: 0,
            reset: false,
            confirm: false,
        }

        //testando

        this.auxItems = [];

        
    }

    $onInit(){
        this.setRegion();
        this.$rootScope.$on('reset:stage', this.resetStage.bind(this));
        this.$rootScope.$on('reset2:stage', this.resetStage2.bind(this));

        this.$rootScope.$on('correctItems', (event, data) => {
            this.auxItems = data;

            this.auxItems.forEach((item, index) => {
                if (item !== undefined){
                    if(this.model.items[index].type === item.type){
                        this.onDrop(null, item, this.model.items[index]);
                    }
                }
            });
        });
    }

    setRegion(){        
        this.device = regions[this.region].device;
        this.model.items = regions[this.region].order;

    }

    setCurrentTab(index){
        this.tabState = index;
        this.$rootScope.$emit('setCurrentTabDevice',index);
    }

    // calc total order
    total(){
        return chain(this.model.items)
                .map(item => item.value ? item.value.price : 0.0)
                .sum()
                .value()
    }

    triggerResetStage(){
        this.toggleReset();
        this.$rootScope.$emit('reset:stage');
    }

    triggerResetStage2(){
        this.toggleReset();
        this.$rootScope.$emit('reset2:stage');
    }

    triggerConfirm(){        
        this.toggleConfirm();
        this.onSubmit();        
    }

    toggleConfirm(){            
        this.state.confirm = !this.state.confirm;
        
        if(!this.state.confirm){
            this.state.step = 0;
        }
    }
    
    toggleReset(){
        this.state.reset = !this.state.reset;
        
        if(!this.state.reset){
            this.state.step = 0;
        }
    }

    toConfirmation(){
        if(this.isEmpty()) return this.openEmpty();
        this.state.step = 1;
    }
    
    resetStage(){
        this.model.items.map((item, index) => this.resetMap(item, index));
    }

    resetStage2(){
        this.model.items.map((item, index) => this.resetMap2(item, index));
    }

    resetMap(item, index){
        if(this.auxItems !== null)
            if (item.value !== this.auxItems[index])
                item.value = null;

        return item;
    }

    resetMap2(item, index){
                item.value = null;
                this.auxItems[index] = null;

        return item;
    }

    renderItemType(item){
        switch (item.type) {
            case PlatesType.entrance:
                return "Entrada"
            case PlatesType.principal:
                return "Prato Principal"
            case PlatesType.dessert:
                return "Sobremesa"
            case PlatesType.drink:
                return "Bebida"            
        }
    }

    onDrop(event, data, item){
        if(!item.value){
            item.value = data;
            this.$rootScope.$emit('tabdevice:drop:success', item.value);
        }
        return true;
    }

    openEmpty(){
        let msg = 'Você ainda não escolheu nenhum item para o seu pedido!';
        let type = 'fail';
        
        this.Dialog.showFeedback(msg, type, () => false);
        return false;
    }

    dropValidate(item, data){
        return item.type === data.type;
    }

    isEmpty(){
        return chain(this.model.items).filter({ value: null}).size().value() === this.model.items.length;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/tab-device/tab-device.controller.js